import { useState, useCallback, useRef } from 'react';

export default function useModalDismissedState(storageKey: string): {
  showOnboarding: boolean;
  dismiss: () => void;
} {
  const keyRef = useRef(storageKey);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(storageKey) === 'true');

  if (keyRef.current !== storageKey) {
    keyRef.current = storageKey;
    const fresh = localStorage.getItem(storageKey) === 'true';
    if (fresh !== dismissed) setDismissed(fresh);
  }

  const dismiss = useCallback(() => {
    localStorage.setItem(storageKey, 'true');
    setDismissed(true);
  }, [storageKey]);

  return { showOnboarding: !dismissed, dismiss };
}
